import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseKey) {
  console.error('Supabase credentials are missing. Please check your environment variables.');
}

// Create a single supabase client for the entire app with proper auth configuration
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    // Automatically refresh the session before it expires
    autoRefreshToken: true,
    // Persist the session in localStorage
    persistSession: true,
    // Detect session from URL (useful for OAuth flows)
    detectSessionInUrl: true,
    // Storage key for the session
    storageKey: 'supabase.auth.token',
    // Use localStorage for session persistence
    storage: window.localStorage,
    // Flow type for authentication
    flowType: 'pkce'
  },
  realtime: {
    // Automatically reconnect when connection is lost
    params: {
      eventsPerSecond: 10
    }
  }
});

// Expose supabase to window for debugging (development only)
if (process.env.NODE_ENV === 'development') {
  (window as any).supabase = supabase;
  console.log('[Supabase] Client available at window.supabase for debugging');
}
